import React from "react";
import { Field, Form as FinalForm } from "react-final-form";
import { observer } from "mobx-react-lite";
import {Button, Slide} from "@mui/material";
import { FormContactCar } from "../../shared/types/widget-types";
import { useStore } from "../../shared/context-provider/context-provider";
import { InputAdapter } from "../components/input-adapter";
import { PlaceAutocomplete } from "../components/place-autocomplete";
import {ColumnFields} from "../components/column-fields";

export const FormTwoDetails = observer(() => {
  const { carStore } = useStore();
  return (
    <Slide in={true} direction={carStore.directionSlide} timeout={500}>
      <div>
        <FinalForm<FormContactCar>
          onSubmit={async (values) => {
            const resErrors = await carStore.handleFormDetails(values);
            if (resErrors) {
              return resErrors;
            }
            return carStore.submitOrder();
          }}
          initialValues={carStore.formInfo}
          validate={carStore.validateFieldsContact}
        >
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit} noValidate>
              <h3 className={"widget-title"}>Get a Quote Now!</h3>
              <div className={"widget-subtitle"}>
                Input your contact details
              </div>
              <ColumnFields>
                <Field
                  name={"name"}
                  allowNull={false}
                  type={"text"}
                  label={"Name*"}
                  component={InputAdapter}
                />
                <Field
                  name={"phone"}
                  allowNull={false}
                  label={"Phone*"}
                  type={"tel"}
                  component={InputAdapter}
                />

                <Field
                  name={"location"}
                  options={carStore.deliveryOptions}
                  type={"text"}
                  label={"Address*"}
                  component={PlaceAutocomplete}
                />

                <Field
                  name={"email"}
                  allowNull={true}
                  type={"email"}
                  label={"E-mail"}
                  component={InputAdapter}
                />
              </ColumnFields>

              <div className={"form-group"}>
                <Button
                  onClick={ev => {
                    ev.preventDefault()
                    carStore.backStep();
                  }}
                  size={'large'}
                  sx={{
                    paddingX: 3,
                    paddingY: 1,
                    borderRadius: 12
                  }}
                  variant={'contained'} color={'primary'}>
                  ← Back
                </Button>
                <Button
                  onClick={handleSubmit}
                  size={'large'}
                  sx={{
                    paddingX: 3,
                    paddingY: 1,
                    borderRadius: 12
                  }}
                  variant={'contained'} color={'success'}>
                  Submit
                </Button>
              </div>
            </form>
          )}
        </FinalForm>
      </div>
    </Slide>
  );
});
